import type { SigningStargateClient, DeliverTxResponse } from '@cosmjs/stargate';
import type { EncodeObject } from '@cosmjs/proto-signing';
import { calculateFee, type StdFee } from '@cosmjs/stargate';

// Gas price for Gravity Bridge (in ugraviton)
const GAS_PRICE = '0.025ugraviton';

export interface SimulateAndBroadcastOptions {
  gasMultiplier?: number;
  memo?: string;
}

export async function simulateAndBroadcast(
  client: SigningStargateClient,
  signerAddress: string,
  messages: EncodeObject[],
  options: SimulateAndBroadcastOptions = {}
): Promise<DeliverTxResponse> {
  const { gasMultiplier = 1.3, memo = '' } = options;

  // Simulate to get gas estimate
  const gasEstimate = await client.simulate(signerAddress, messages, memo);

  // Apply buffer for safety
  const gasLimit = Math.ceil(gasEstimate * gasMultiplier);

  // Calculate fee
  const fee = calculateFee(gasLimit, GAS_PRICE);

  // Broadcast transaction
  return await client.signAndBroadcast(signerAddress, messages, fee, memo);
}

export function calculateTxFee(gasLimit: number): StdFee {
  return calculateFee(gasLimit, GAS_PRICE);
}

export function formatTxHash(hash: string): string {
  if (hash.length <= 16) return hash;
  return `${hash.slice(0, 8)}...${hash.slice(-8)}`;
}

export function isSuccessfulTx(response: DeliverTxResponse): boolean {
  return response.code === 0;
}
